// extracted by mini-css-extract-plugin
module.exports = {"actions":"ConsentActions_actions__3MM1F"};